export default __webpack_public_path__ + "static/media/phoneFill.bf6a1dda.png";